
<div class="closed-message">
    <svg-icon
        icon="close"
        class="icon--danger"
    /><span class="closed-message__text"><slot /></span>
</div>
